import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import BlockModel, { ItemListModel } from '@aytm/app/insights/dashboard/models/BlockModel'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'
import { getMinSampleSize } from '@aytm/app/insights/dashboard/helpers/filters'
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'
import type { WaveIntervalsType, SubjectType, PresetsType } from '@aytm/app/insights/dashboard/models/types.ClientDTO'

const defaultPresets = { All: { _: [] } } as PresetsType

export type StateSelectorParams = {
  blockModel?: BlockModel | null
  currentSplit: string | null
  chartType: string
  chartScale: string
  subjects: Record<string, SubjectType>
  presets: PresetsType
  waves: WaveIntervalsType
  items: ItemListModel | null
  showRowAverages: boolean
  minSampleSize?: number
  isSharedView?: boolean
  canUpdateDashboard?: boolean
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const block = getCurrentBlock(state)
  const currentSplit = block?.get<string>('currentSplit') || null
  const chartType = currentSplit
    ? block?.get<string>('blockChartType') || 'column'
    : block?.get<string>('dataChartType') || 'line'
  const chartScale = currentSplit
    ? block?.get<string>('blockChartScale') || 'min-max'
    : block?.get<string>('dataChartScale') || 'min-max'
  const subjects = state.currentData?.subjects || {}
  const presets = state.currentData?.presets || defaultPresets
  const waves = state.currentData?.waves || {}
  const items = block?.getBlockItems()
  const showRowAverages = block?.get<boolean>('showRowAverages') || false
  const minSampleSize = getMinSampleSize(state)
  return {
    blockModel: block || null,
    currentSplit,
    chartType,
    chartScale,
    subjects,
    presets,
    waves,
    items,
    showRowAverages,
    minSampleSize,
    isSharedView: staticStore.isSharedView,
    canUpdateDashboard: staticStore.canUpdateDashboard
  }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : prev.currentSplit !== next.currentSplit ||
      prev.chartType !== next.chartType ||
      prev.chartScale !== next.chartScale ||
      prev.subjects !== next.subjects ||
      prev.presets !== next.presets ||
      prev.waves !== next.waves ||
      prev.items !== next.items ||
      prev.showRowAverages !== next.showRowAverages ||
      prev.minSampleSize !== next.minSampleSize ||
      prev.isSharedView !== next.isSharedView ||
      prev.canUpdateDashboard !== next.canUpdateDashboard ||
      prev.blockModel !== next.blockModel
